import React, { Component } from "react";
import { Select } from "../../component/Select";
import { Tab, Nav, Row, Col, Image } from "react-bootstrap";
import { sectorWiseProjects } from "../../actions/common.action";
import { formatNumberOnDashBoard, isValidArray } from "../../helper";
import NoDataFound from "../../component/NoDataFound";
import _costIcon from "../../assets/project-cost-state.png";
import _projectIcon from "../../assets/project-count-state.png";
import { getPath } from "./SectorsWheel/sectorWheel.selector";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

class SectorWise extends Component {
  state = {
    sectorWiseData: [],
    selectedOption: null,
    selectedData: {}
  };

  componentDidMount() {
    this.getSectorWiseData();
  }

  getSectorWiseData = async () => {
    let response = await sectorWiseProjects();
    if (response && response.status) {
      this.setState({ sectorWiseData: response.data.data });
    }
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption });
  };

  render() {
    const { sectorWiseData, selectedOption } = this.state;
    let sectorWiseDataOptions = [];
    let selectedData = {};
    if (isValidArray(sectorWiseData)) {
      sectorWiseDataOptions = sectorWiseData.map(item => {
        return {
          value: item.sectorName,
          name: item.sectorName
        };
      });
      if (selectedOption) {
        selectedData = sectorWiseData.find(sector => {
          if (sector.sectorName === selectedOption.value) return sector;
          return null;
        });
      }
    }

    return (
      <React.Fragment>
        {sectorWiseData && sectorWiseData.length ? (
          <Tab.Container
            defaultActiveKey={
              sectorWiseData.length && sectorWiseData[0].sectorName
            }
          >
            <div className="sector-wise-wrapper">
              <Tab.Content className="sector-wise-content">
                {sectorWiseData.map((sectorDetails, index) => {
                  return (
                    <Tab.Pane
                      eventKey={sectorDetails.sectorName}
                      key={`sector-details-${index}`}
                    >
                      <div className="sector-wise-content-inner">
                        <div className="sector-content">
                          <div className="sector-content-left">
                            <h3 data-test="sector-name">
                              {selectedData.sectorName ||
                                sectorDetails.sectorName}
                            </h3>
                            <div className="sector-image">
                              <div className={"image-parent"}>
                                <div className={"image"}>
                                  <Image
                                    src={getPath(sectorDetails.sectorName)}
                                    alt="photo"
                                    loading="lazy"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="sector-content-right">
                            <div
                              className="stats-wrapper"
                              data-test="stats-wrapper"
                            >
                              <div className="project-stats">
                                <div className="stats-img">
                                  <Image src={_projectIcon} alt="Projects" />
                                </div>
                                <div className="sector-stats">
                                  <b data-test="sectorwise-project-count">
                                    {sectorDetails.projectCount}
                                  </b>{" "}
                                  Project(s)
                                </div>
                              </div>
                              <div className="issue-stats">
                                <div className="stats-img">
                                  <Image src={_costIcon} alt="Cost" />
                                </div>
                                <div className="sector-stats">
                                  {sectorDetails.projectCost && (
                                    <b data-test="sectorwise-project-investment">
                                      {formatNumberOnDashBoard(
                                        Number(
                                          sectorDetails.projectCost.toFixed(1)
                                        ),
                                        true,
                                        true,
                                        "."
                                      )}
                                    </b>
                                  )}{" "}
                                  Project(s) Investment
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                  );
                })}
              </Tab.Content>
              <div className="sector-wise-list">
                <PerfectScrollbar className="field-mscb-scroll">
                  <div>
                    <Nav className="flex-column sector-wise-names">
                      {sectorWiseData &&
                        sectorWiseData.map((sector, index) => {
                          return (
                            <Nav.Item key={`sector-${index}`}>
                              <Nav.Link eventKey={sector.sectorName}>
                                <span data-test="nav-item-sector-name">
                                  {sector.sectorName}
                                </span>
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                    </Nav>
                  </div>
                </PerfectScrollbar>
                <div className="sector-wise-name-dropdown">
                  <Select
                    value={selectedOption}
                    onChange={this.handleChange}
                    options={sectorWiseDataOptions}
                    getOptionLabel={option => option && option.name}
                    getOptionValue={option => option && option.value}
                  />
                </div>
              </div>
            </div>
          </Tab.Container>
        ) : (
          <NoDataFound />
        )}
      </React.Fragment>
    );
  }
}

export default SectorWise;
